<script lang="ts">

  type BenefitTagProps = {
    variationId: string;
  }

  let {variationId}: BenefitTagProps = $props();
</script>

<ft9-benefit-tag-v1
    class="benefit-tag"
    id={variationId}
    feature="recoSpa"
    team="hopper"
    variation-id={variationId}
    remove-expired
    load-on-visibility>
</ft9-benefit-tag-v1>


<style lang="scss">
  .benefit-tag {
    display: inline-flex;
  }
</style>
